import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import useIntersectionObserver from '../useIntersectionObserver';
import '../styles.css'; // Ensure you import your CSS file

const Projects = () => {
    useIntersectionObserver();
    const [hoveredIndex, setHoveredIndex] = useState(null); // State to track hovered row

    const projects = [
        {
            title: "WordyPals",
            link: "https://wordypalslcaplatfo.wixsite.com/my-site-1",
            type: "Application/Game",
            description: "Developed an AI-powered English learning app for young learners (K2 to P1). Integrated advanced AI features: difficulty adjustment, personalized learning, intelligent error correction, speech/image recognition, and NLP. Supported deployment across 12+ schools with over 100 active users.",
            tags: ["Unity", "C#", "Firebase"],
            image: "images/WordyPals.png",
        },
        {
            title: "MindVoyage",
            link: "https://apps.apple.com/app/mindvoyage/id6753164049",
            type: "Application/Game",
            description: "Developed an English learning platform for students and teachers under EdUHK’s Research Team. Managed a team of 3 developers and implemented core systems including authentication, student and teacher lobbies, and multi-role access architecture.",
            tags: ["Unity", "C#", "PostgreSQL", "Linux", "Ubuntu Server", "Python", "FastAPI"],
            image: "images/MindVoyage.png",
        },
        {
            title: "Real-time Multiplayer Game",
            link: "https://youtu.be/fqLggAzfWwE",
            type: "Game",
            description: "Developed a 3D ARPG online game. Implemented player movement and ability, third-person camera controls, enemy AI behavior, animation controller, user interface components, inventory system, and combat mechanics. Won the Best Creativity Award in HKGD GCE 2024.",
            tags: ["Unity", "C#", "Netcode"],
            image: "images/FYP.png",
        },
        // {
        //     title: "Peer-to-peer Music Sharing System",
        //     type: "Software",
        //     description: "Developed a graphical music player focusing on user interface and music management functionalities.",
        //     tags: ["Python"],
        //     image: "images/MusicPlayer.png",
        // },
        // {
        //     title: "Buzzer - Social Media Platform",
        //     type: "Web",
        //     description: "Developed a microblogging and social networking service that allows users to share their thoughts, opinions, and ideas in real-time. Inspired by the popular platform Twitter.",
        //     tags: ["HTML", "CSS", "JavaScript", "React", "Node.js", "MongoDB", "Express"],
        //     image: "images/Buzzer.png",
        // },
    ];

    return (
        <section id="projects" className="py-5">
            <div className="container hidden">
                <h2 className="title">Projects</h2>

                {projects.map((project, index) => (
                    <div
                        key={index}
                        className={`project-row ${hoveredIndex === index ? 'hovered' : hoveredIndex === null ? 'default' : ''}`} // Apply hovered class
                        onMouseEnter={() => setHoveredIndex(index)} // Set hovered index on mouse enter
                        onMouseLeave={() => setHoveredIndex(null)} // Reset hovered index on mouse leave
                    >
                        <div className="project-image">
                            <img src={project.image} alt={project.title} />
                        </div>
                        <div className="project-details">
                            {/* Only show link if project.link is not empty */}
                            {/* Link color is white */}
                            {project.link && (
                                <h3><a className="nav-link" href={project.link} target="_blank" rel="noopener noreferrer">{project.title}</a></h3>
                            )}
                            {!project.link && (
                                <h3>{project.title}</h3>
                            )}
                            <p><strong>{project.type}</strong></p>
                            <p>{project.description}</p>
                            <ul className="tag-list">
                                {project.tags.map((tag, tagIndex) => (
                                    <li key={tagIndex}><div className="tag">{tag}</div></li>
                                ))}
                            </ul>
                        </div>
                    </div>
                ))}

                {/* Link to View All Projects */}
                <Link className="nav-link-ind" to="/archive">
                    View All Projects
                    {/* SVG Icon */}
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="go-logo" aria-hidden="true">
                        <path fillRule="evenodd" d="M3 10a.75.75 0 01.75-.75h10.638L10.23 5.29a.75.75 0 111.04-1.08l5.5 5.25a.75.75 0 010 1.08l-5.5 5.25a.75.75 0 11-1.04-1.08l4.158-3.96H3.75A.75.75 0 013 10z" clipRule="evenodd"></path>
                    </svg>
                </Link>
            </div>
        </section>
    );
};

export default Projects;